import { Helmet } from 'react-helmet';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
     Button, Form, Spinner
} from 'react-bootstrap';
import { contact } from './../api';
function ContactUs() {

    const title = 'Payment';
    const navigate = useNavigate();
    //const dispatch = useDispatch();

    const [data, setData] = useState({
        Email: "",
        FirstName: "",
        LastName: "",
        BusinessName: "",
        Message: "",
        Phone: "",
        Question: ""
    });

    const [errors, setErrors] = useState({});
    const [isSend, setIsSend] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const requiredFields = {
        FirstName: "First Name",
        LastName: "Last Name",
        Email: "Email",
        Question: "Question"
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prevData => ({ ...prevData, [name]: value }));
    };

    const resetErrors = () => {
        setErrors({});
    };

    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value) {
            return "Email address is required.";
        } else if (!emailRegex.test(value)) {
            return "Please enter a valid email address.";
        }
        return null;
    };

    const isValidPhoneNumber = (phone) => {
        return /^(?:\([0-9]{3}\))?(?:[0-9]{3})?[ -]?[0-9]{3}[ -]?[0-9]{4}$/.test(phone);
    };

    const validatePhones = () => {
        if (!data.Phone) {
            return "A phone number is required.";
        }
        if (data.Phone && !isValidPhoneNumber(data.Phone)) {
            return "Please enter a valid phone number.";
        }
        return null;
    };

    const validateQuestion = () => {
        if (!data.Question) {
            return "Anti-Bot Question is required.";
        }
        if (data.Question && data.Question !== "4") {
            return "Please enter a valid answer.";
        }
        return null;
    };

    const formValidation = () => {
        resetErrors();
        let newErrors = {};

        Object.keys(requiredFields).forEach((field) => {
            if (!data[field]) {
                newErrors[field] = `${requiredFields[field]} is required.`;
            }
        });

        const emailError = validateEmail(data.Email);
        if (emailError) newErrors.Email = emailError;

        const phoneError = validatePhones();
        if (phoneError) newErrors.Phone = phoneError;

        const questionError = validateQuestion();
        if (questionError) newErrors.Question = questionError;

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const next = async () => {
        if (formValidation()) {
            setIsLoading(true);
            let formattedData = { ...data };
            formattedData.Email = formattedData.Email.toLowerCase();
            formattedData.Phone = formattedData.Phone.replace(/[() -]/g, "");

            try {
                
                const response = await contact(formattedData);
              
                if (response.status===200) {
                    setIsSend(true);
                } else {
                    // Handle error
                    console.error('Failed to send contact form');
                }
            } catch (error) {
                console.error('Error sending contact form:', error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const goHomePage = () => {
        navigate('/');
    };


    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <div className="container-fluid py-5 py-sm-7">
      {!isSend ? (
        <div className="row mx-auto align-content-center" style={{ maxWidth: "50rem", minHeight: "70vh" }}>
          <div className="row justify-content-lg-l">
            <div className="col-12">
              <div className="card mb-5 bg-white">
                <div className="card-header bg-white pt-3 px-4">
                  <h4 className="text-secondary">Request to Discuss Interest in Enterprise Account</h4>
                </div>
                <div className="card-header bg-white pt-3 px-4">
                  <p>
                    Please provide the information requested below so that AccessEVA may contact you to:
                  </p>
                  <ul>
                    <li>explain the enhanced benefits for an Enterprise Account;</li>
                    <li>determine the number of seat licenses your Enterprise may need;</li>
                    <li>calculate the associated Annual Subscription amount for your seat licenses;</li>
                    <li>present and formalize a one-page Services Agreement for the Site and Services; and</li>
                    <li>answer any questions your may have about AccessEVA.</li>
                  </ul>
                  <p>Thank You!</p>
                  <p>In the alternative, you may send an email to <a href="mailto:sales@AccessEVA.ai">sales@AccessEVA.ai</a> and await a direct response to your email.</p>
                </div>
                <div className="card-body px-4">
                  <Form>
                    <div className="row gy-2">
                      <div className="col-sm-6">
                        <Form.Group controlId="FirstName">
                          <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="FirstName"
                            value={data.FirstName}
                            onChange={handleInputChange}
                            isInvalid={!!errors.FirstName}
                            placeholder="First Name"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.FirstName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="col-sm-6">
                        <Form.Group controlId="LastName">
                          <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="LastName"
                            value={data.LastName}
                            onChange={handleInputChange}
                            isInvalid={!!errors.LastName}
                            placeholder="Last Name"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.LastName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="row gy-2">
                      <div className="col-sm-12">
                        <Form.Group controlId="BusinessName">
                          <Form.Label>Business Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="BusinessName"
                            value={data.BusinessName}
                            onChange={handleInputChange}
                            placeholder="Business Name"
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <div className="row gy-2">
                      <div className="col-sm-6">
                        <Form.Group controlId="Email">
                          <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="email"
                            name="Email"
                            value={data.Email}
                            onChange={handleInputChange}
                            isInvalid={!!errors.Email}
                            placeholder="Email"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.Email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="col-sm-6">
                        <Form.Group controlId="Phone">
                          <Form.Label>Phone Number <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="tel"
                            name="Phone"
                            value={data.Phone}
                            onChange={handleInputChange}
                            isInvalid={!!errors.Phone}
                            placeholder="Phone Number"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.Phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="row gy-2">
                      <div className="col-sm-12">
                        <Form.Group controlId="Message">
                          <Form.Label>Message</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="Message"
                            value={data.Message}
                            onChange={handleInputChange}
                            placeholder="Message"
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <div className="row gy-2">
                      <div className="col-sm-12">
                        <Form.Group controlId="Question">
                          <Form.Label>Anti-Bot Question: What is 2 + 2? <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="Question"
                            value={data.Question}
                            onChange={handleInputChange}
                            isInvalid={!!errors.Question}
                            placeholder="Anti-Bot Question: What is 2 + 2?"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.Question}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-md-12 mt-3">
                      <p><span className="text-danger">*</span>All red asterisk fields are required.</p>
                    </div>
                    <div className="col-md-12">
                      <Button variant="primary" onClick={next} disabled={isLoading}>
                        {isLoading ? <Spinner animation="border" size="sm" /> : 'Next'}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row mx-auto align-content-center" style={{ maxWidth: "50rem", minHeight: "70vh" }}>
          <div className="card card-lg mb-5 bg-white border-0">
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  <div className="mb-4">
                    <h3 className="text-secondary">Thank You!</h3>
                    <p>We appreciate your reaching out to AccessEVA through our contact form. Management will contact you soon!</p>
                    <Button variant="primary" size="lg" onClick={goHomePage}>Back to Home Page</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
        </>
    );
}

export default ContactUs;